define('views/modules/supervisor/supervisor-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/list',
    'views/modules/supervisor/supervisor-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VList,
    VSupervisorListItem
) {

    var VSupervisorList = VList.extend({
        item: VSupervisorListItem,

        getItemOptions: function(options) {
            return _.extend(options, _.pick(this.options, ['url', 'group']));
        },

        onUpdate: function() {
            this.render();
        },
    });

    return VSupervisorList;
});

